import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { ToastType } from "@/enums";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast, displayToast } from "@/utils/toast";

export const useEditOrganization = (userToken: string) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ organizationId, name }: { organizationId: number; name: string }) =>
      fetch(`${ENDPOINTS.organizations}/${organizationId}`, {
        method: "PATCH",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify({
          name,
        }),
      }).then(handleResponse),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ENDPOINTS.organizations]);
        displayToast("Organization name updated", ToastType.success);
      },
      onError: () => {
        displayErrorToast("Failed to update organization name");
      },
    },
  );
};
